// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SXt9_1QRDrLRuOhx40XT {
  min-height: calc(100vh - 100px);
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: white;
  padding-top: 3.25rem;
  display: flex;
  flex-direction: column;
}
@media screen and (min-width: 800px) {
  .SXt9_1QRDrLRuOhx40XT {
    padding-left: 14rem;
  }
}
.SXt9_1QRDrLRuOhx40XT .hero {
  background-color: #eef4f4;
}
.SXt9_1QRDrLRuOhx40XT::-webkit-scrollbar {
  width: 8px !important;
}
.SXt9_1QRDrLRuOhx40XT::-webkit-scrollbar-thumb {
  background: #ddd;
  border-radius: 5px;
}

#navbar-main {
  margin-right: 8px;
}`, "",{"version":3,"sources":["webpack://./packages/aiand-scenario/frontend/src/components/AdminLayout/Layout.module.scss"],"names":[],"mappings":"AAAA;EACE,+BAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,oBAAA;EACA,aAAA;EACA,sBAAA;AACF;AAAE;EATF;IAUI,mBAAA;EAGF;AACF;AAFE;EACE,yBAAA;AAIJ;AADE;EACE,qBAAA;AAGJ;AADE;EACE,gBAAA;EACA,kBAAA;AAGJ;;AAEE;EACE,iBAAA;AACJ","sourceRoot":""}]);
// Exports
export var layout = `SXt9_1QRDrLRuOhx40XT`;
export default ___CSS_LOADER_EXPORT___;
